import { memo, ReactElement } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Row } from '../Row';
import { Checkbox } from '../Checkbox';
import { TOptionValue } from './Types';

interface IChipOptionProps<T> extends TOptionValue<T> {
  isChecked?: boolean;
  onClick: (value: T, isChecked: boolean) => void;
}

const Component = <T extends string | number = string>({
  isChecked = false,
  label,
  value,
  onClick,
}: IChipOptionProps<T>) => (
  <Row
    backgroundColor={colors.shades[0]}
    borderColor={isChecked ? colors.secondary[500] : colors.neutral[100]}
    borderRadius={8}
    borderStyle="solid"
    borderWidth={1.5}
    cursor="pointer"
    data-testid={`multi-select-group.options.${label}`}
    role="button"
    tabIndex={0}
    onClick={() => onClick(value, !isChecked)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(value, !isChecked);
      }
    }}
    gap={8}
    paddingBlock={8}
    paddingInline={16}
    alignItems='center'
  >
    <Checkbox checked={isChecked} />
    <Typography as="span">{label}</Typography>
  </Row>
);

export const ChipOption = memo(Component) as <T extends string | number = string>(
  props: IChipOptionProps<T>,
) => ReactElement;
